var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditDocumentOutlined = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "transparent",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8",
  stroke: "currentColor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2514 1.75015C12.5166 1.48493 12.8763 1.33594 13.2514 1.33594C13.6264 1.33594 13.9861 1.48493 14.2514 1.75015C14.5166 2.01537 14.6656 2.37508 14.6656 2.75015C14.6656 3.12522 14.5166 3.48493 14.2514 3.75015L8.2427 9.75948C8.0844 9.91765 7.88883 10.0334 7.67403 10.0962L5.7587 10.6562C5.70133 10.6729 5.64052 10.6739 5.58264 10.6591C5.52475 10.6442 5.47192 10.6141 5.42966 10.5719C5.38741 10.5296 5.35729 10.4768 5.34246 10.4189C5.32763 10.361 5.32863 10.3002 5.34536 10.2428L5.90536 8.32748C5.96838 8.11285 6.08439 7.91752 6.2427 7.75948L12.2514 1.75015Z",
  stroke: "currentColor",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditDocumentOutlined);
export default ForwardRef;